import { padZeroes } from '..';

/**
 * Converts a Date instance to a time string like '6:01:30 PM'.
 * If padHours is `true`, the hours section is paddded with a leading zero (when necessary) to be
 * two digits long, i.e. '06:01:30 PM'.
 * @param date a Date instance
 * @param padHours whether to pad hours with a leading zero when necessary
 */
export const dateToTime = (date: Date, padHours = false): string => {
    const formatter = new Intl.DateTimeFormat('en', {
        calendar: 'gregory',
        hour: 'numeric',
        minute: 'numeric',
        second: 'numeric',
        hour12: true,
    });

    const formatParts = formatter.formatToParts(date);

    const hours = formatParts.find(
        ({ type }: DateFormatPart): boolean => type === 'hour',
    );

    const minutes = formatParts.find(
        ({ type }: DateFormatPart): boolean => type === 'minute',
    );

    const seconds = formatParts.find(
        ({ type }: DateFormatPart): boolean => type === 'second',
    );

    const dayPeriod = formatParts.find(
        ({ type }: DateFormatPart): boolean => type === 'dayPeriod',
    );

    const displayStrings = {
        hours: hours?.value ?? '00',
        minutes: minutes?.value ?? '00',
        seconds: seconds?.value ?? '00',
    };

    if (padHours) {
        displayStrings.hours = padZeroes(displayStrings.hours, 2);
    }

    return `${displayStrings.hours}:${displayStrings.minutes}:${
        displayStrings.seconds
    } ${dayPeriod?.value ?? 'AM'}`;
};
